import nodeListToArray from '../util/nodeListToArray';
function serializeInput(name, value) {
  return "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value));
}
function serializeForm(formElement) {
  const inputNodes = nodeListToArray(formElement.querySelectorAll('input, textarea, select'));
  const data = [];
  Array.from(inputNodes).forEach(element => {
    const eleType = element.getAttribute('type');
    const eleName = element.getAttribute('name');
    if (eleName) {
      if (eleType === 'checkbox' || eleType === 'radio') {
        if (element.checked) {
          data.push(serializeInput(eleName, element.value || 'on'));
        }
      } else {
        data.push(serializeInput(eleName, element.value));
      }
    }
  });
  return data.join('&');
}
export default serializeForm;